import React from "react";

const commentContext = React.createContext();

export default commentContext;
